import {get, post, put, _delete} from './Tools';

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}acomulado/${id}`);
  return response;
};
const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}acomulado`);
  return response;
};
const getAllByConcept = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}acomulado/concepto/${conceptId}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}acomulado`, payload);
  return response;
};
const insertWithRelation = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}acomulado/concepto`, payload);
  return response;
};
const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}acomulado/${id}`);
  return response;
};

const getByConfiguration = async (empleadoId, periodId, anio, num_period) => {
  const response = await get(`${process.env.REACT_APP_SERVER}acomulado/${empleadoId}/${periodId}/${anio}/${num_period}`);
  return response;
};

export { getAll, getAllByConcept, getById, insert, insertWithRelation, drop, getByConfiguration };
